import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClickhouseService } from '../../../shared/services/clickhouse.service';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../../store/state/app.state';
import { combineLatest } from 'rxjs';
import { hasSubscriptionSelector, isVipSelector } from '../../../store/selectors/billing.selectors';
import { Router } from '@angular/router';
import { isFreeUserRegisteredSelector } from '../../../store/selectors/event-variables.selectors';
import { isMobileMenuShownSelector } from '../../../store/selectors/system.selectors';
import { toggleMobileMenu } from '../../../store/actions/system.actions';
import { AppModalService } from '../../../shared/services/app-modal.service';
import { eventIdSelector, uuidSelector } from '../../../store/selectors/profile.selectors';
import { NavigationService } from './navigation.service';

const downloadAppModalContent = `
  <img src="../../../../assets/download-app.png" alt="" class="download-app-modal_img">
`;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  private hasSubscription: boolean = false;

  isVip: boolean | null = false;

  userIsFree: boolean = false;

  isMobileMenuShown: boolean = false;

  currentPath: string = '';

  eventId: string = '';

  token: string = '';

  constructor(
    private modalService: NgbModal,
    private modalPopup: AppModalService,
    private clickHouse: ClickhouseService,
    private store: Store<AppStateInterface>,
    private router: Router,
    private navigationService: NavigationService,
  ) {
    combineLatest([
      this.store.select(isVipSelector),
      this.store.select(hasSubscriptionSelector),
      this.store.select(isFreeUserRegisteredSelector),
      this.store.select(isMobileMenuShownSelector),
      this.store.select(eventIdSelector),
      this.store.select(uuidSelector),
    ]).subscribe(
      ([isVip, hasSubscription, isFreeUserRegistered, isMobileMenuShown, eventIdValue, uuid]) => {
        this.isVip = isVip;
        this.hasSubscription = hasSubscription;
        this.userIsFree = isFreeUserRegistered;
        this.isMobileMenuShown = isMobileMenuShown;
        this.eventId = eventIdValue;
        this.token = uuid;
      },
    );
  }

  ngOnInit(): void {
    this.currentPath = this.router.url.split('?')[0];
    this.router.events.subscribe(() => {
      this.currentPath = this.router.url.split('?')[0];
    });

    // Register this component instance with the service
    this.navigationService.setNavigationComponentInstance(this);
  }

  openBillingModal() {
    if (this.hasSubscription) {
      import('../../modals/billing-modal/billing-modal-component.module').then(
        ({ BillingModalComponentModule }) => {
          const BillingModalComponent = BillingModalComponentModule.getComponent();
          this.modalService.open(BillingModalComponent, {
            backdrop: 'static',
            keyboard: false,
          });
        },
      );
    } else {
      import('../../modals/plan-modal/plan-modal-component.module').then(
        ({ PlanModalComponentModule }) => {
          const PlanModalComponent = PlanModalComponentModule.getComponent();
          this.modalService.open(PlanModalComponent, {
            backdrop: 'static',
            keyboard: false,
          });
        },
      );
    }
  }

  async openLogoutModal() {
    this.clickHouse.storeEvent('logout_click').subscribe(() => {});

    import('../../modals/question-modal/question-modal-component.module').then(
      ({ QuestionModalComponentModule }) => {
        const QuestionModalComponent = QuestionModalComponentModule.getComponent();
        this.modalService.open(QuestionModalComponent, {
          backdrop: 'static',
          keyboard: false,
        });
      },
    );
  }

  openVipComponent() {
    this.router.navigate(['/vip']);
    // this.openVipModal();
  }

  openDownloadAppModal() {
    this.clickHouse.storeEvent('download_app_click').subscribe(() => {});

    this.modalPopup.open({
      subtitle: 'Welcome to our service ImproveMath (MathMaster)',
      customSubtitleClass: 'fw-bold download-app-modal_subtitle',
      title:
        'For your convenience we suggest you <span class="download-app-modal_subtitle-accent">to install our mobile app MathMaster</span>. It`s the best way to get solutions as fast as possible whenever you need it. Solution is already there.',
      customTitleClass: 'download-app-modal_title',
      canClose: true,
      content: downloadAppModalContent,
      additionalQRCode: `https://mathmaster.onelink.me/Vtkz/hrqip26o?eventid=${this.eventId}&token=${this.token}`,
      token: this.token,
      eventId: this.eventId,
    });
  }

  closeMobileMenu() {
    this.clickHouse.storeEvent('mobile_menu_close_click').subscribe(() => {});
    this.store.dispatch(toggleMobileMenu());
  }
}
